import React from 'react';
import { SvgIcon } from "@material-ui/core";

export default (props: any) => (
  <SvgIcon {...props} width="14" height="14" viewBox="0 0 14 14">
    <path fill="currentColor" d="M13.83 5.782L8.581.182c-.167-.177-.417-.231-.635-.135-.218.096-.36.324-.36.575v2.492C4.232 3.26 1.306 5.678.368 9.142c-.405 1.502-.374 2.722-.362 3.182l.002.12c0 .28.176.526.428.6.052.015.104.023.155.023.202 0 .394-.113.5-.304 2.31-4.143 5.37-4.26 6.496-4.143v3.202c0 .252.142.48.36.575.218.097.468.043.635-.135l5.247-5.6c.228-.243.228-.636 0-.88z"/>
  </SvgIcon>
);